import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AdminSidebar from '../components/AdminSidebar';
import './VendorWiseDetails.css';

function VendorWiseDetails() {
  const { vendorId } = useParams();
  const [data, setData] = useState([]);
  const [vendorName, setVendorName] = useState('Vendor');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [openGroups, setOpenGroups] = useState({});

  useEffect(() => {
    fetch('https://ideatorportal.in/api/get_vendor_material.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: `vendor_id=${vendorId}`,
    })
      .then(res => res.json())
      .then(res => {
        if (res.status === 'success') {
          const materials = res.materials || [];
          setData(materials);
          setVendorName(res.vendor_name || 'Vendor');

          // Collapse all JC groups by default
          const initialGroups = {};
          materials.forEach(item => {
            const jc = item.jc_number || 'Unassigned';
            initialGroups[jc] = false;
          });
          setOpenGroups(initialGroups);
        } else {
          setError(res.message || 'Failed to fetch data');
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Fetch error:', err);
        setError('Network error');
        setLoading(false);
      });
  }, [vendorId]);

  const grouped = data.reduce((acc, item) => {
    const jc = item.jc_number || 'Unassigned';
    acc[jc] = acc[jc] || [];
    acc[jc].push(item);
    return acc;
  }, {});

  const overallTotal = data.reduce((sum, item) => sum + parseFloat(item.total || 0), 0);

  const toggleGroup = jc => {
    setOpenGroups(prev => ({
      ...prev,
      [jc]: !prev[jc],
    }));
  };

  return (
    <div className="vendor-wise-page">
      <AdminSidebar />
      <div className="vendor-details__container">
        {loading && <div className="vendor-details__loading">Loading materials...</div>}
        {error && <div className="vendor-details__error">Error: {error}</div>}
        {!loading && !error && data.length === 0 && (
          <>
            <h2 className="vendor-details__heading">{vendorName}'s Materials</h2>
            <p>No material records found for this vendor.</p>
          </>
        )}
        {!loading && !error && data.length > 0 && (
          <>
            <div className="vendor-details__header">
              <h2 className="vendor-details__title">{vendorName}'s Materials</h2>
              <div className="vendor-details__total">
                Total Amount: ₹{overallTotal.toLocaleString('en-IN')}
              </div>
            </div>

            {Object.entries(grouped).map(([jc, materials]) => {
              const isOpen = openGroups[jc];
              const total = materials.reduce((sum, m) => sum + parseFloat(m.total || 0), 0);

              return (
                <div key={jc} className="vendor-details__group">
                  <div
                    className="vendor-details__jc-toggle"
                    onClick={() => toggleGroup(jc)}
                    style={{
                      cursor: 'pointer',
                      fontWeight: 'bold',
                      fontSize: '1.1rem',
                      marginBottom: '0.5rem',
                      backgroundColor: '#f0f0f0',
                      padding: '8px 12px',
                      borderRadius: '6px',
                    }}
                  >
                    {isOpen ? '▼' : '▶'} JC Number: {jc}
                  </div>

                  {isOpen && (
                    <>
                      <div className="vendor-details__table-container">
                        <table className="vendor-details__table">
                          <thead>
                            <tr>
                              <th>Item</th>
                              <th>Unit</th>
                              <th>Qty</th>
                              <th>Price</th>
                              <th>GST</th>
                              <th>Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            {materials.map((m, i) => (
                              <tr key={i}>
                                <td>{m.item_name}</td>
                                <td>{m.unit}</td>
                                <td>{m.quantity}</td>
                                <td>₹{m.price}</td>
                                <td>{parseFloat(m.gst) }%</td>
                                <td className="text-right">₹{parseFloat(m.total).toFixed(2)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <p className="vendor-details__po-total">
                        JC Total: ₹{total.toLocaleString('en-IN')}
                      </p>
                    </>
                  )}
                </div>
              );
            })}
          </>
        )}
      </div>
    </div>
  );
}

export default VendorWiseDetails;
